import Box from "@mui/material/Box";
import { GET_STARTED_LINKS, navLinks } from "../../constants";
import { buildOctantProductPath, OCTANT_NAV_LINKS } from "../../services/octant/octantPageService";
import { MdaiLink } from "../MdaiLink";
import { LinkDropdown } from "./LinkDropdown";

const octantEnabled = import.meta.env.VITE_OCTANT_ENABLED === "true";

export function HeaderLinks() {
  const platformGroup = navLinks.find((g) => g.groupName === "Platform");
  const otherHeaderGroups = navLinks.filter(
    (g) => g.header && g.groupName !== "Platform",
  );

  return (
    <Box sx={{ display: { sm: "none", md: "flex" }, alignItems: "center" }}>
      {octantEnabled && (
        <LinkDropdown groupName="Product" links={OCTANT_NAV_LINKS} />
      )}
      {platformGroup && (
        <LinkDropdown
          groupName={platformGroup.groupName}
          links={platformGroup.links}
        />
      )}
      {octantEnabled && (
        <MdaiLink
          type="button"
          variant="text"
          style={{ color: "#fff !important" }}
          label={"Open Source"}
          href={buildOctantProductPath("open-source")}
        />
      )}
      {otherHeaderGroups.map(({ groupName, links }) => (
        <LinkDropdown key={groupName} groupName={groupName} links={links} />
      ))}
      <LinkDropdown groupName="Get Started" links={GET_STARTED_LINKS} />
    </Box>
  );
}
